import { publish, subscribe, unsubscribe } from '@wh/message-bus';

import { EVENT_ACCOUNT_FLAG_GET, COMMAND_ACCOUNT_FLAG_GET } from './events';
import { FlagNames, ACCOUNT_FLAGS_REQUESTED } from './constants';

export var getCountDownFlag = function getCountDownFlag(data) {
  return data && Array.isArray(data.flags) ? data.flags.find(function (flag) {
    return flag.name === FlagNames.JUMIO_COUNTDOWN;
  }) : null;
};

export var checkIfAccountVerified = function checkIfAccountVerified(flagsCb) {
  var noFlagsCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  var flagsRequestedTimeout = null;
  var flagSubscriber = subscribe({
    topic: EVENT_ACCOUNT_FLAG_GET,
    callback: function callback(_ref) {
      var data = _ref.data;

      if (data.state === ACCOUNT_FLAGS_REQUESTED) {
        flagsRequestedTimeout = setTimeout(function () {
          return publish(COMMAND_ACCOUNT_FLAG_GET);
        }, 50);
        return false;
      }
      var countDownFlag = getCountDownFlag(data);
      if (countDownFlag) {
        flagsCb(countDownFlag);
      } else {
        noFlagsCb();
      }
      if (flagsRequestedTimeout) {
        clearTimeout(flagsRequestedTimeout);
      }
      return unsubscribe(flagSubscriber);
    }
  });
  publish(COMMAND_ACCOUNT_FLAG_GET);
};